// functions/and.ts
import "../validator.js";
var and = (...fns) => (options) => Promise.all(fns.map((fn) => fn(options))).then((results) => results.every(Boolean));
export {
  and
};
